var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart_component"},[_c('main',[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"icon"},[_c('span',[_c('i',{class:_vm.icon})]),_c('h3',{staticClass:"number"},[_vm._v(_vm._s(_vm.number))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }